<template>
  <div class="invoice-create-page main-content">
    <div class="page-header">
      <h3 class="page-title">{{ $tc('profile.title') }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link slot="item-title" to="/supplier/dashboard">{{ $t('general.home') }}</router-link></li>
        <li class="breadcrumb-item"><router-link slot="item-title" to="/supplier/profile/business-status">{{ $tc('profile.title') }}</router-link></li>
      </ol>
    </div>
    <div class="row settings-container">
      <div class="col-lg-4 settings-sidebar-container">
        <ol class="settings-sidebar">
          <li v-for="(menuItem, index) in menuItems" :key="index" class="settings-menu-item">
            <router-link :class="['link-color', {'active-setting': hasActiveUrl(menuItem.link)}]" :to="menuItem.link">
              <font-awesome-icon :icon="[menuItem.iconType, menuItem.icon]" class="setting-icon"/>
              <span class="menu-title ml-3">{{ $t(menuItem.title) }}</span>
            </router-link>
          </li>
          <li class="settings-menu-item">
            <a class='link-color' :href="`/company/BBFS/pdf/${user}`" target="_blank">
              <font-awesome-icon icon="eye" class="setting-icon"/>
              <span class="menu-title ml-3">{{ $t('general.view_bbfs') }}</span>
            </a>
          </li>
        </ol>
      </div>
      <div class="col-lg-8">
        <transition
          name="fade"
          mode="out-in">
          <router-view/>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      user:null,
      menuItems: [
        {
          link: '/supplier/profile/business-status',
          title: 'profile.menu_title.business_status',
          icon: 'building',
          iconType: 'fa'
        },
        {
          link: '/supplier/profile/borrower-profile',
          title: 'profile.menu_title.borrower_profile',
          icon: 'user-tie',
          iconType: 'fa'
        },
        {
          link: '/supplier/profile/stakeholder',
          title: 'profile.menu_title.stakeholder',
          icon: 'user-friends',
          iconType: 'fa'
        },
        {
          link: '/supplier/profile/business_financial_institutions',
          title: 'profile.menu_title.business_financial_institutions',
          icon: 'landmark',
          iconType: 'fa'
        },
        {
          link: '/supplier/profile/financial_facilities',
          title: 'profile.menu_title.financial_facilities',
          icon: 'exchange-alt',
          iconType: 'fa'
        },
        {
          link: '/supplier/profile/rescheduling_restructuring',
          title: 'profile.menu_title.writeOff_rescheduling_restructuring',
          icon: 'pencil-alt',
          iconType: 'fas'
        },
        {
          link: '/supplier/profile/documents',
          title: 'profile.menu_title.documents',
          icon: 'file-contract',
          iconType: 'fa'
        },
        {
          link: '/supplier/profile/sharing_profile_code',
          title: 'profile.menu_title.sharing_profile_code',
          icon: 'share',
          iconType: 'fa'
        },
      ]
    }
  },
  watch: {
    '$route.path' (newValue) {
      if (newValue === '/supplier/profile') {
        this.$router.push('/supplier/profile/business-status')

      }
    }

  },
  created () {
    if (this.$route.path === '/supplier/profile') {
      this.$router.push('/supplier/profile/business-status')
    }
    if(localStorage.getItem('selectedCompany')){
      this.user=localStorage.getItem('selectedCompany');
    }
  },
  methods: {
    hasActiveUrl (url) {
      return this.$route.path.indexOf(url) > -1
    },
  }

}


</script>
